const PositionTabIcon = ({ color = "#303030" }: { color?: string }) => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.8311 13.5716L15.2069 12.9474L17.092 11.0623C17.1264 11.0279 17.1264 10.972 17.092 10.9375L15.2069 9.05265L15.8311 8.42847L17.7162 10.3135C18.0946 10.692 18.0946 11.3081 17.7162 11.6865L15.8311 13.5716Z"
                fill={color}
            />
            <path d="M17.7792 10.5584H4.22189V11.441H17.7792V10.5584Z" fill={color} />
            <path
                d="M6.16893 13.5716L4.28385 11.6865C3.90538 11.3081 3.90538 10.692 4.28385 10.3135L6.16876 8.42847L6.79294 9.05247L4.90803 10.9375C4.87361 10.972 4.87361 11.0279 4.90803 11.0623L6.79294 12.9474L6.16893 13.5716Z"
                fill={color}
            />
            <path
                d="M11 18C10.7515 18 10.5027 17.9054 10.3135 17.7162L8.42842 15.8311L9.0526 15.2069L10.9377 17.092C10.9721 17.1264 11.0281 17.1264 11.0625 17.092L12.9476 15.2069L13.5718 15.8311L11.6865 17.716C11.4973 17.9054 11.2485 18 11 18Z"
                fill={color}
            />
            <path d="M11.4413 14.3887H10.5587V17.7792H11.4413V14.3887Z" fill={color} />
            <path d="M11.4411 4.22195H10.5585V13.259H11.4411V4.22195Z" fill={color} />
            <path
                d="M12.9474 6.79299L11.0625 4.90809C11.0281 4.87367 10.9721 4.87367 10.9377 4.90809L9.0526 6.79299L8.4286 6.16881L10.3137 4.28391C10.6921 3.90545 11.308 3.90527 11.6867 4.28391L13.5718 6.16881L12.9474 6.79299Z"
                fill={color}
            />
        </svg>
    );
};

export default PositionTabIcon;
